export const selectTestPlans = (state) => state.testPlans.testPlans;
export const selectTestPlansCount = (state) => state.testPlans.testPlansCount;
export const selectTestPlanActual = (state) => state.testPlans?.testPlanActual;
export const selectTestPlanLocal = (state) => state.testPlans?.testPlanLocal;

export const selectGetTestPlansStatus = (state) => state.testPlans.getStatus;
export const selectGetTestPlanStatus = (state) => state.testPlans.getTestPlanByIdStatus;
export const selectAddTestPlanStatus = (state) => state.testPlans.addStatus;
export const selectEditTestPlanStatus = (state) => state.testPlans?.editStatus;
export const selectDeleteTestPlanStatus = (state) => state.testPlans.deleteStatus;
export const selectDuplicateTestPlanStatus = (state) => state.testPlans.duplicateStatus;

export const selectGetTestPlansErrorInfo = (state) => state.testPlans.getError;
export const selectGetTestPlanErrorInfo = (state) => state.testPlans.getTestPlanByIdError;
export const selectAddTestPlanErrorInfo = (state) => state.testPlans.addError;
export const selectEditTestPlanErrorInfo = (state) => state.testPlans.editError;
export const selectDeleteTestPlanErrorInfo = (state) => state.testPlans.deleteError;
export const selectDuplicateTestPlanErrorInfo = (state) => state.testPlans.duplicateError;

export const selectIsTestPlanEverSaved = (state) => state.testPlans.isTestPlanEverSaved;

export const selectAddedTestplanId = (state) => state.testPlans.addedTestplanId;

export const selectTestCasesFilteredByTestPlan = (state) => state.testPlans.testCasesFilteredByTestPlan;
export const selectTestCasesFilteredByTestPlanCount = (state) => state.testPlans.testCasesFilteredByTestPlanCount;

export const selectGetTestCasesFilteredByTestPlanStatus = (state) =>
    state.testPlans?.getTestCasesFilteredByTestPlanStatus;

export const selectGetTestCasesFilteredByTestPlanError = (state) => state.testPlans.getTestCasesFilteredByTestPlanError;
export const selectAddTestcasesToTestplanStatus = (state) => state.testPlans.addTestcasesToTestplanStatus;
export const selectAddTestcasesToTestplanError = (state) => state.testPlans.addTestcasesToTestplanError;
export const selectDeleteTestcasesFromTestplanStatus = (state) => state.testPlans.deleteTestcasesFromTestplanStatus;
export const selectDeleteTestcasesFromTestplanError = (state) => state.testPlans.deleteTestcasesFromTestplanError;
export const selectTestplanType = (state) => state.testPlans.testplanType;
export const selectGetTestplanTypeStatus = (state) => state.testPlans.getTestplanTypeStatus;
export const selectGetTestplanTypeError = (state) => state.testPlans.getTestplanTypeError;
